import { axiosInstance } from '../api';

export default function(patientFhirId, force) {
    return axiosInstance.get(`/fhir/Patient/${patientFhirId}`, {
        headers: force ? {
            'Cache-Control': 'no-cache'
        } : undefined
    });
}